import { KeyIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Password = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <KeyIcon size={Sizes[size]} {...rest} color={fill} />;
};

Password.displayName = 'Password';
